/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { useParams,Link,useNavigate } from 'react-router-dom';
import axios from "axios";

import DatePicker from "react-datepicker";
import { ko } from 'date-fns/esm/locale';
import "react-datepicker/dist/react-datepicker.css";

import HeaderTitle from "../../components/includes/HeaderTitle";
import { isObjEmpty,ChangeSearchingDateFormat,escapeHtml,unescapeHtml } from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";

const StaffAnnualDetail = ({setMenuType,setMenuItem}) => {
  let { sa_idx } = useParams();
  const admin_idx = Number(localStorage.getItem('adminIdx'));
  const admin_name = localStorage.getItem('adminName');
  const navigator = useNavigate();

  //회원정보
  const [varStaffAnnualInfo,setStaffAnnualInfo] = useState({});
  //기본정보
  const newData = {sa_idx:Number(sa_idx),mem_idx:admin_idx,mem_id:'',mem_name:admin_name,st_department:0,st_position:0,
                sa_qdate:ChangeSearchingDateFormat(new Date(),'-'),sa_comment:null,sa_status:1}

  //회원정보 읽어오기
  const getStaffAnnualInformation = async () => {
    const sendData = {sa_idx:sa_idx,mem_idx:admin_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/admin_get_staff_annual_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      let bMode = false;
      if(datas.retvalue === 1) {
        if(datas.results?.length > 0){
          bMode = true;
          let dataInfo = datas.results[0];
          setStaffAnnualInfo(dataInfo);
        }
      } 
      const membInfo = datas.membInfo[0];
      if(!bMode) {
        const newAnnual = {...newData};
        newAnnual.mem_id = membInfo.mem_id;
        newAnnual.mem_name = membInfo.mem_name;
        newAnnual.st_department = membInfo.st_department;
        newAnnual.st_position = membInfo.st_position;
        newAnnual.vd_name = membInfo.vd_name;
        newAnnual.vp_name = membInfo.vp_name;
        setStaffAnnualInfo(newAnnual);
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setMenuType('MEMBER');
    setMenuItem('StaffAnnualList');
    getStaffAnnualInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //입력정보
  const onChangeInputHandler = (e) => {
    const {name,value} = e.currentTarget;
    setStaffAnnualInfo({...varStaffAnnualInfo,[name]:escapeHtml(value)});
  }
  //날짜
  const [varAnnualDate,setAnnualDate] = useState(new Date());
  const onChangeDateHandler = (date) => {
    setAnnualDate(date);
    setStaffAnnualInfo({...varStaffAnnualInfo,sa_qdate:ChangeSearchingDateFormat(date,'-')})
  }

  //연차신청등록
  const onUpdateStaffAnnualHandler = async(e) => {
    const sendData = {dataInfo:varStaffAnnualInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_register_staff_annual`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      alert(datas.message);
      if(datas.retvalue === 1) {
        //목록페이지로 이동
        navigator(`/Admin/StaffAnnualList`);
      }
    });
  } 

  return (
    <div id="admin_contents" className="ad_contents">
      <HeaderTitle varMenuTitle="직원관리" varPageTitle="연차신청" />
      {isObjEmpty(varStaffAnnualInfo)?null:
        <div className="admin-content">
          <div className="main-box">
            <table className="write">
              <colgroup>
                <col width="20%"/><col width="20%"/>
                <col width="15%"/><col width="15%"/>
                <col width="15%"/><col width="15%"/>
              </colgroup>
              <thead></thead>
              <tbody>
                <tr>
                  <th>아이디</th>
                  <td>{varStaffAnnualInfo.mem_id}</td>
                  <th>부서</th>
                  <td>{varStaffAnnualInfo.vd_name}</td>
                  <th>직위</th>
                  <td>{varStaffAnnualInfo.vp_name}</td>
                </tr>
                <tr>
                  <th>작성자</th>
                  <td>{varStaffAnnualInfo.mem_name}</td>
                  <th>신청일자</th>
                  <td colSpan={3}>
                    <DatePicker locale={ko} name="adate" className="datepicker" dateFormat="yyyy.MM.dd" selected={varAnnualDate} selectStart onChange={(date)=>onChangeDateHandler(date)} />
                  </td>
                </tr>
                <tr>
                  <th>신청사유</th>
                  <td colSpan={5}><textarea name="sa_comment" value={unescapeHtml(varStaffAnnualInfo.sa_comment)} onChange={onChangeInputHandler}/></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="btn-center">
            <button className="btn-danger" style={{width:"120px"}} onClick={(e)=>onUpdateStaffAnnualHandler(e)}>연차신청등록</button>
            <Link to={`/Admin/StaffAnnualList`} className="btn line">목록</Link>
          </div>
        </div>
      }
    </div>   
  );

}
export default StaffAnnualDetail;